import React from 'react';
import { Alert, Snackbar, Stack } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { IconButton } from '@mui/material';
import AddEditTag from './AddEditTag';
import tagsService from '../../../../services/api/insights/tagService';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { OutlineButton } from '../../../../resources/styling/appStyle';
import surveyTagService from '../../../../services/api/insights/surveyTagService';

const { mandy, pictonBlue } = colors;

export default function TagRow({
  tag,
  selectedTag,
  setSelectedTag,
  updateListAfterEdit,
  UpdateListAfterDelete,
}) {
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [showOutput, setShowOutput] = React.useState({
    open: false,
    message: '',
    type: 'success',
  });

  const editTag = () => {
    setSelectedTag(tag);
    setOpenEdit(true);
  };

  const editTagDone = (doneOrCancel, t) => {
    setOpenEdit(false);
    if (doneOrCancel === 'done') {
      updateListAfterEdit(t);
      setShowOutput({
        open: true,
        message: 'Tag updated successfully',
        type: 'success',
      });
    }
  };

  const deleteTag = () => {
    surveyTagService
      .deleteTag(tag.id)
      .then((res) => {
        if (res) {
          setOpenDelete(false);
          UpdateListAfterDelete(tag);
          setShowOutput({
            open: true,
            message: 'Tag deleted successfully',
            type: 'success',
          });
        } else {
          setOpenDelete(true);
          setShowOutput({
            open: true,
            message: 'Tag not deleted',
            type: 'error',
          });
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div
      className={
        tag.id === selectedTag?.id
          ? 'questions-library-selected'
          : 'questions-library'
      }
      style={{ cursor: 'pointer' }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={showOutput.open}
        autoHideDuration={6000}
        onClose={() => setShowOutput({ ...showOutput, open: false })}
      >
        <Alert
          variant='filled'
          onClose={() => setShowOutput({ ...showOutput, open: false })}
          severity={showOutput.type}
          sx={{ width: '100%' }}
        >
          {showOutput.message}
        </Alert>
      </Snackbar>
      <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 3,
          }}
        >
          <Grid container>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <h2>Delete Tag</h2>
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12} mt={3}>
              <Alert severity='warning'>This action cannot be undone.</Alert>
              <p>
                Are you sure you want to delete the <strong>{tag.tag}</strong>{' '}
                tag?
              </p>
            </Grid>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <Stack direction={'row'} justifyContent='flex-end' spacing={1}>
                <OutlineButton onClick={() => setOpenDelete(false)}>
                  Cancel
                </OutlineButton>
                <AppButton color={mandy} onClick={deleteTag}>
                  Delete
                </AppButton>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <div className='question-list' onClick={(e) => setSelectedTag(tag)}>
        <Stack
          onClick={(e) => setSelectedTag(tag)}
          direction={'row'}
          justifyContent='space-between'
          alignItems='center'
        >
          <div className='question-txt'>{tag.tag}</div>
          <Stack direction={'row'} alignItems='center' spacing={2}>
            {tag.id === selectedTag?.id ? (
              <Stack direction={'row'} alignItems='center' spacing={1.5}>
                <IconButton
                  onClick={() => setOpenDelete(true)}
                  disableRipple
                  sx={{ padding: '0px' }}
                >
                  <svg
                    width='14'
                    height='16'
                    viewBox='0 0 14 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M2.83325 15.5001C2.37492 15.5001 1.9827 15.3371 1.65658 15.011C1.33047 14.6848 1.16714 14.2923 1.16659 13.8335V3.00012H0.333252V1.33346H4.49992V0.500122H9.49992V1.33346H13.6666V3.00012H12.8333V13.8335C12.8333 14.2918 12.6702 14.6843 12.3441 15.011C12.018 15.3376 11.6255 15.5007 11.1666 15.5001H2.83325ZM11.1666 3.00012H2.83325V13.8335H11.1666V3.00012ZM4.49992 12.1668H6.16658V4.66679H4.49992V12.1668ZM7.83325 12.1668H9.49992V4.66679H7.83325V12.1668Z'
                      fill='#626262'
                    />
                  </svg>
                </IconButton>
                <IconButton
                  onClick={editTag}
                  disableRipple
                  sx={{ padding: '0px' }}
                >
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M2.16667 13.8335H3.35417L11.5 5.68762L10.3125 4.50012L2.16667 12.646V13.8335ZM0.5 15.5001V11.9585L11.5 0.979289C11.6667 0.826511 11.8508 0.708455 12.0525 0.625122C12.2542 0.541789 12.4658 0.500122 12.6875 0.500122C12.9092 0.500122 13.1244 0.541789 13.3333 0.625122C13.5422 0.708455 13.7228 0.833455 13.875 1.00012L15.0208 2.16679C15.1875 2.31957 15.3092 2.50012 15.3858 2.70846C15.4625 2.91679 15.5006 3.12512 15.5 3.33346C15.5 3.55568 15.4619 3.76762 15.3858 3.96929C15.3097 4.17096 15.1881 4.35484 15.0208 4.52096L4.04167 15.5001H0.5ZM10.8958 5.10429L10.3125 4.50012L11.5 5.68762L10.8958 5.10429Z'
                      fill='#626262'
                    />
                  </svg>
                </IconButton>
              </Stack>
            ) : (
              ''
            )}
            <ArrowForwardIosSharpIcon sx={{ fontSize: '12px' }} />
          </Stack>
        </Stack>
      </div>
      <AddEditTag
        openEdit={openEdit}
        setSelectedTag={setSelectedTag}
        editTagDone={editTagDone}
        selectedTag={selectedTag}
        mode={'edit'}
      />
    </div>
  );
}
